import { render, staticRenderFns } from "./supplierCompanyInfo.vue?vue&type=template&id=d5bf9994&"
import script from "./supplierCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./supplierCompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports